/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresDeleteEntry } from "../../funcs/llmMemoryStoresDeleteEntry.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteMemoryEntryRequest$inboundSchema,
};

export const tool$llmMemoryStoresDeleteEntry: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-delete-entry",
  description: `Delete memory entry`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresDeleteEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
